/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Faqheading1Inputs */

const he_contact_faqheading1 = /** @type {(inputs: Contact_Faqheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שאלות נפוצות`)
};

const en_contact_faqheading1 = /** @type {(inputs: Contact_Faqheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Contact_Faqheading1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_faqheading1 = /** @type {((inputs?: Contact_Faqheading1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Faqheading1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_faqheading1(inputs)
	return en_contact_faqheading1(inputs)
});
export { contact_faqheading1 as "contact_faqHeading" }